<template>
  <div>
    <a-card
      :bordered="false"
      hoverable
      :bodyStyle="bodyStyle"
      style="margin: 0px 30px 20px 30px"
      v-if="data.parseResultDetail != undefined"
      @click="detailTwitter(data)"
    >
      <a-row>
        <a-col :span="24">
          <img
            src="@/assets/Site/ExhibitionBoard/twitter.png"
            alt=""
            style="width: 33.9px; height: 33.9px; margin-top: -5px"
          />
          <div class="titleTwItter" style="display: inline">
            {{ data.parseResultDetail.name === undefined ? '' : data.parseResultDetail.name }}
          </div>
          <div
            style="
              width: 64px;
              height: 12px;
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 14px;
              display: inline;
              margin-left: 27px;
            "
          >
            {{ data.parseResultDetail.publishTime }}
          </div>
          <div style="margin-left: 20px">
            <div style="margin-left: 28px">
              <div class="contentTwItter" style="">
                {{ data.parseResultDetail.tweet }}
              </div>
              <div style="margin-top: 12px" v-if="data.parseResultDetail.photoList != undefined">
                <div
                  v-for="(item, index) in data.parseResultDetail.photoList"
                  :key="index"
                  style="display: inline"
                >
                  <img
                    :src="item"
                    alt=""
                    style="width: 260px; height: 162px; border-radius: 6px; margin-right: 12px"
                  />
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
      title="媒体详情"
      :footer="null"
      :visible="visible"
      width="1010px"
      @cancel="visible = false"
    >
      <SelfMediaInfo :mediaData="mediaData" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import SelfMediaInfo from './SelfMediaInfo'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['data', 'tabState'],
  data() {
    return {
      stateName: this.tabState,
      type: '',
      typeName: '',
      case: 'style1',
      isA: true,
      isB: false,
      isC: false,
      isD: false,
      visible: false,
      mediaData: {},
      bodyStyle: {
        padding: '27px 62px 30px 43px'
      }
    }
  },
  created() {
    // this.List = this.$store.state.localLX
  },
  computed: {},
  mounted() {
    // this.dema()
  },
  components: { SelfMediaInfo },
  beforeDestroy() {},
  methods: {
    detailTwitter(data) {
      this.mediaData = data.parseResultDetail
      this.mediaData.mediaType = 'twitter'
      this.visible = true
    },
    showImg(data) {
      let str = data.parseResultDetail.photos
      return JSON.parse(str)
    },
    compareSrc(param) {
      if (param === null) {
        if (this.data.typeMetaId === 53) {
          return this.defaultSrcMl
        }
        return this.defaultSrc
      } else {
        return `/pmc/hdfs/show/app_icon/${this.data.id}`
      }
    },
    resetDATE(record) {
      const a = moment(record).format('YYYY-MM-DD HH:mm:ss')
      const b = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      if (moment(b).diff(moment(a), 'minutes') <= 0) {
        return '刚刚更新'
      }
      if (moment(b).diff(moment(a), 'minutes') <= 60) {
        return moment(b).diff(moment(a), 'minutes') + '分钟前更新'
      }
      if (
        moment(b).diff(moment(a), 'minutes') > 60 &&
        moment(b).diff(moment(a), 'minutes') < 60 * 24
      ) {
        return moment(b).diff(moment(a), 'hours') + '小时前更新'
      }
      if (moment(b).diff(moment(a), 'days') < 30) {
        return moment(b).diff(moment(a), 'days') + '天前更新'
      } else {
        return moment(b).diff(moment(a), 'months') + '月前更新'
      }
    },
    pictureReturn(id) {
      pictureFind(id).then((res) => {
        return res
      })
    },
    changePage() {
      // this.$router.push({ path: '/productCenter/productOverview' })
      this.$store.commit('saveLocalData', this.data)
      this.$router.push({ path: `/productMangement/productOverview/overview/${this.data.id}` })
    },
    dema(data) {
      switch (data) {
        case 7:
          return '#9DAAC9'
        case 8:
          return '#DEC898'
        case 9:
          return '#99C1D3'
        case 10:
          return '#B9A5D5'
        case 11:
          return '#98C08E'
        default:
          break
      }
    },
    checkColor() {
      // const color = this.dema(data)
      const a = {
        width: '116px',
        height: '30px',
        background: this.data.typeMetaColor,
        'border-radius': '2px',
        position: 'absolute',
        right: '-30px',
        top: '-30px'
      }
      return a
    },
    checkList(data) {
      let returname = ''
      this.List.forEach((element) => {
        if (data === element.id) {
          returname = element.metaValue
        }
      })
      return returname
    }
  }
}
</script>

<style scoped>
#dividerFormat /deep/ .ant-divider,
.ant-divider-vertical {
  margin: 0 20px;
}
.titleTwItter {
  margin-top: 4px;
  display: inline;
  font-size: 18px;
  font-weight: bold;
  color: #1f2e4c;
  line-height: 14px;
  margin-left: 12px;
}
.contentTwItter {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  /* margin-top: 17px; */
}
.TwItterOscen {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  line-height: 14px;
  display: inline;
}
.TwItterTime {
  font-size: 12px;
  font-weight: 400;
  color: #bbbbbb;
  line-height: 14px;
  display: inline;
  margin-left: 30px;
}
.ywlj {
  font-size: 12px;
  font-weight: 400;
  color: #bbbbbb;
  line-height: 14px;
  display: inline;
  float: right;
  margin-right: 12px;
  text-decoration: underline;
}
</style>
